import * as React from 'react'
import { PreviewCard as BasePreviewCard } from '@base-ui/react/preview-card'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

export interface BackdropProps extends PartProps<React.ComponentProps<typeof BasePreviewCard.Backdrop>> {
  className?: string
}

export function Backdrop({ className, ...props }: BackdropProps) {
  return <BasePreviewCard.Backdrop className={twMerge('', className)} {...props} />
}
